import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderByPipe } from '../../../shared/pipe/order-by.pipe';

@Component({
  selector: 'app-actual-equipment-modal',
  templateUrl: './actual-equipment-modal.component.html',
  styleUrls: ['./actual-equipment-modal.component.css']
})
export class ActualEquipmentModalComponent implements OnInit {
  @Input() equipments: any[];
  @Input() selected: number;

  formData: any = {};
  orderByPipe: OrderByPipe;

  equipmentNotUsed: boolean;
  filteredEquipments: any[];
  shownEquipments: any[];
  searchString: string = "";
  sortByOptions: any[];
  currentSort: any;

  constructor(public activeModal: NgbActiveModal) {
    this.orderByPipe = new OrderByPipe();
  }

  ngOnInit(): void {
    this.equipmentNotUsed = true;
    this.sortByOptions = [
      { title: 'Equipment Description Ascending', name: 'EquipmentDescription', isDescending: false },
      { title: 'Equipment Description Descending', name: 'EquipmentDescription', isDescending: true },
      { title: 'Job Ascending', name: 'Job', isDescending: false },
      { title: 'Job Descending', name: 'Job', isDescending: true },
      { title: 'Transfer Date Ascending', name: 'TransferDate', isDescending: false },
      { title: 'Transfer Date Descending', name: 'TransferDate', isDescending: true },
      { title: 'Estimate Return Date Ascending', name: 'EstReturnDate', isDescending: false },
      { title: 'Estimate Return Date Descending', name: 'EstReturnDate', isDescending: true }
    ];

    this.formData.itemsPerPage = 10;
    this.formData.sortByValue = this.sortByOptions[0];
    this.currentSort = this.formData.sortByValue;
    this.formData.currentPage = 1;
    this.updateFilter();
  }

  setFiltered() {
    this.filteredEquipments = [];
    var searchString = this.searchString.toLowerCase();
    this.equipments.forEach((equipment: any) => {
      var filters = false;
      Object.entries(equipment).forEach(([key, val]) => {
        if (val && val.toString().toLowerCase().includes(searchString)) {
          filters = true;
        }
      })
      var notUsedOnly = (this.equipmentNotUsed && !equipment.Job) || !this.equipmentNotUsed;
      if (filters && notUsedOnly) {
        this.filteredEquipments.push(equipment);
      }
    })
  }

  sortBy() {
    this.filteredEquipments = this.orderByPipe.transform(this.filteredEquipments, this.formData.sortByValue.name, this.formData.sortByValue.isDescending ? "desc" : "asc")
  }

  setTableSorting(type: any) {
    if (type == 'EquipmentDescription') {
      if (this.formData.sortByValue && this.formData.sortByValue.isDescending == false && this.formData.sortByValue.name == 'EquipmentDescription') {
        this.formData.sortByValue = this.sortByOptions[1];
      }
      else {
        this.formData.sortByValue = this.sortByOptions[0];
      }
    }
    else if (type == 'Job') {
      if (this.formData.sortByValue && this.formData.sortByValue.isDescending == false && this.formData.sortByValue.name == 'Job') {
        this.formData.sortByValue = this.sortByOptions[3];
      }
      else {
        this.formData.sortByValue = this.sortByOptions[2];
      }
    }
    else if (type == 'TransferDate') {
      if (this.formData.sortByValue && this.formData.sortByValue.isDescending == false && this.formData.sortByValue.name == 'TransferDate') {
        this.formData.sortByValue = this.sortByOptions[5];
      }
      else {
        this.formData.sortByValue = this.sortByOptions[4];
      }
    }
    else if (type == 'EstReturnDate') {
      if (this.formData.sortByValue && this.formData.sortByValue.isDescending == false && this.formData.sortByValue.name == 'EstReturnDate') {
        this.formData.sortByValue = this.sortByOptions[7];
      }
      else {
        this.formData.sortByValue = this.sortByOptions[6];
      }
    }
    this.updateFilter();
  }

  setPage() {
    this.shownEquipments = [];
    var tens = (this.formData.currentPage - 1) * 10;
    for (var i = 0; i < 10; i++) {
      var index = i + tens;
      if (index == this.filteredEquipments?.length) {
        break;
      }
      else {
        this.shownEquipments.push(this.filteredEquipments[index]);
      }
    }
  }

  useSelected(selectedValue: any) {
    this.activeModal.close(selectedValue);
  }

  cancel() {
    this.activeModal.close();
  };

  updateFilter() {
    this.setFiltered();
    this.sortBy();
    this.setPage();
  }
}